import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Avatar, Dropdown, Typography, Space } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  UserOutlined,
  FileTextOutlined,
  TeamOutlined,
  DropboxOutlined,
  FileProtectOutlined,
  SettingOutlined,
  EnvironmentOutlined,
  LogoutOutlined,
  CloudOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import './ResponsiveLayout.css';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

const ResponsiveLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const location = useLocation();
  
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const userRole = localStorage.getItem('role')?.toLowerCase();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const getMenuItems = () => {
    const baseItems = [
      {
        key: `/${userRole}/dashboard`,
        icon: <DashboardOutlined />,
        label: 'Dashboard',
      },
      {
        key: `/${userRole}/clients`,
        icon: <TeamOutlined />,
        label: 'Clients',
      },
    ];

    if (userRole === 'admin') {
      return [
        ...baseItems,
        {
          key: `/${userRole}/contracts`,
          icon: <FileTextOutlined />,
          label: 'Contrats',
        },
        {
          key: `/${userRole}/utilisateurs`,
          icon: <UserOutlined />,
          label: 'Utilisateurs',
        },
        {
          key: `/${userRole}/consommations`,
          icon: <DropboxOutlined />,
          label: 'Consommations',
        },
        {
          key: `/${userRole}/factures`,
          icon: <FileProtectOutlined />,
          label: 'Factures',
        },
        {
          key: `/${userRole}/tranches`,
          icon: <SettingOutlined />,
          label: 'Tranches',
        },
        {
          key: `/${userRole}/secteurs`,
          icon: <EnvironmentOutlined />,
          label: 'Secteurs',
        },
      ];
    } else if (userRole === 'tech') {
      return [
        ...baseItems,
        {
          key: `/${userRole}/consommation`,
          icon: <DropboxOutlined />,
          label: 'Consommation',
        },
        {
          key: `/${userRole}/factures`,
          icon: <FileProtectOutlined />,
          label: 'Factures',
        },
      ];
    }

    return baseItems;
  };

  const handleMenuClick = ({ key }) => {
    navigate(key);
    if (isMobile) {
      setCollapsed(true);
    }
  };

  const userMenuItems = [
    // {
    //   key: 'profile',
    //   icon: <UserOutlined />,
    //   label: 'Profil',
    // },
    // {
    //   type: 'divider',
    // },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Déconnexion',
      onClick: handleLogout,
    },
  ];

  return (
    <Layout className="responsive-layout">
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className="layout-sider"
        breakpoint="lg"
        collapsedWidth={isMobile ? 0 : 80}
        onBreakpoint={(broken) => {
          setIsMobile(broken);
          if (broken) {
            setCollapsed(true);
          }
        }}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 1000,
        }}
      >
        <div className="layout-logo">
          <img src={logo} alt="Abar" className="logo-image" />
          {!collapsed && <span className="logo-text">Abar</span>}
        </div>
        
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={getMenuItems()}
          onClick={handleMenuClick}
          className="layout-menu"
        />
      </Sider>

      <Layout style={{ marginLeft: isMobile ? 0 : (collapsed ? 80 : 200) }}>
        <Header className="layout-header">
          <div className="header-left">
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              className="collapse-btn"
            />
            <CloudOutlined className="header-icon" />
            <Text className="header-title">
              Système de Gestion de l'Eau
            </Text>
          </div>

          <div className="header-right">
            <Dropdown
              menu={{
                items: userMenuItems,
                onClick: ({ key }) => {
                  if (key === 'logout') {
                    handleLogout();
                  }
                },
              }}
              placement="bottomRight"
              arrow
            >
              <Space className="user-info">
                <Avatar icon={<UserOutlined />} />
                <Text className="user-name">
                  {user.prenom || user.nom || 'Utilisateur'}
                </Text>
              </Space>
            </Dropdown>
          </div>
        </Header>

        <Content className="layout-content">
          <div className="content-wrapper">
            {children}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default ResponsiveLayout;
